import PropTypes from 'prop-types';
import React, { memo } from 'react';
import classNames from 'classnames';
import { List } from 'immutable';

import LoadAnimation from '../../decorators/LoadAnimation';
import { ActionContextMenu } from './ActionContextMenu';
import { TargetRow } from './TargetRow';
import { BuyerRow } from './BuyerRow';
import { ExecRow } from './ExecRow';

import style from './style.module.css';

const Table = LoadAnimation(
  ({ setGridReference, rows }) => (
    <div ref={setGridReference} style={{ overflow: 'auto', height: '100%' }}>
      <table className={classNames(style.table, 'table table-hover table-striped')}>
        <tbody>{rows}</tbody>
      </table>
    </div>
  ),
  'isFetching',
  style.host,
);

/**
 * Stateless component for showing next action.
 *
 * @param props {Object}.
 * @param props.list {Immutable.List} List of next actionList.
 * @param props.actionConfigs {Immutable.List} List of available actionList for each event.
 * @param props.isFetching {Boolean} Show spinner if true.
 * @param props.onRowSelected {Function} To handle row selection.
 * @param props.onMenuSelect {Function} To handle context menu item click event.
 * @param props.setGridReference {Function} To handle setting grid ref.
 * @param props.onBLClick {Function} To handle setting backlog.
 */
const Grid = props => {
  const {
    backloggedActivities,
    list,
    isFetching,
    actionConfigs,
    setGridReference,
    onRowSelected,
    onMenuSelect,
    onBLClick,
  } = props;

  const rows = list.map((action, index) => mapRow(action, index + 1, backloggedActivities, onBLClick, onRowSelected));

  return (
    <>
      <Table isFetching={isFetching} rows={rows} setGridReference={setGridReference} />
      <ActionContextMenu actionConfigs={actionConfigs} id="actionContextMenu" onItemClick={onMenuSelect} />
    </>
  );
};

Grid.propTypes = {
  actionConfigs: PropTypes.instanceOf(List).isRequired,
  isFetching: PropTypes.bool.isRequired,
  list: PropTypes.instanceOf(List).isRequired,
  onBLClick: PropTypes.func.isRequired,
  onMenuSelect: PropTypes.func.isRequired,
  onRowSelected: PropTypes.func.isRequired,
  setGridReference: PropTypes.func.isRequired,
};

export default memo(Grid);

function mapRow(action, index, backloggedActivities, onBLClick, onRowSelected) {
  const approach = action.get('approach');

  if (approach === 'target') {
    return (
      <TargetRow
        key={index}
        action={action}
        backloggedActivities={backloggedActivities}
        index={index}
        onClick={onBLClick}
        onRowSelected={onRowSelected}
      />
    );
  }

  if (approach === 'buyer') {
    return <BuyerRow key={index} action={action} index={index} onRowSelected={onRowSelected} />;
  }

  return <ExecRow key={index} action={action} index={index} onRowSelected={onRowSelected} />;
}
